import { AdapterState } from '@tronweb3/tronwallet-abstract-adapter';
import { useWallet } from '@tronweb3/tronwallet-adapter-react-hooks';

export function useTronAddress() {
  const { wallets } = useWallet();

  return useMemo(
    () =>
      wallets.find((wallet) => wallet.state == AdapterState.Connected)?.adapter
        .address || undefined,
    [wallets],
  );
}
